export default {
  message: {
    "error": "Bir hata oluştu!",
    "Sorrysomeerrorsoccurred": "Üzgünüm bazı hatalar oluştu",
    "quit": "Çıkış",
    "language": "Dil",
    "Youcanchangethelanguagehere": "Burası dil değişikliği yapabileceğin yer!",
    "current": "Mevcut",
    "home": "Anasayfa",
    "friends": "Arkadaşlar",
    "wallet": "Cüzdan",
    "aboutus": "Hakkımızda",
    "Sharewithfriends": "Arkadaşlarla paylaş",
    "copyFailure": "Kopyalama Hatası",
    "copySuccess": "Kopyalama Başarılı",
    "Claimreward": "Ödülü topla",
    "DailyLogin": "Günlük Giriş",
    "noInvitationsYet": "Henüz Davetiyeler Yok",
    "LoadMore": "Daha Fazla Yükle",
    "WatchAD": "Reklam İzle",
    "continue": "Devam Et",
    "Congratulations": "Tebrikler",
    "MyFriends": "Arkadaşlarım",
    "Invitefriends": "Arkadaşları davet et",
    "Invitepremiumfriends": "Premium arkadaşları davet et",
    "DailyTasks": "Günlük görevler",
    "inviteDesc": "Her davet edilen arkadaş için +{num} ${name}",
    "DailyTasksDesc": "Daha fazla ${name} kazanmak için görevleri tamamla",
    "SponsorsandPartners": "Destekçiler ve Ortaklar",
    "Receivingwallet": "Alım cüzdanı",
    "Enterwalletaddress": "{name} cüzdan adresini gir",
    "Claim": "Ödül al",
    "Booster": "Booster",
    "RentPeriod": "Kiralama Süresi",
    "days30": "30 gün",
    "days": "gün",
    "Dailyprofit": "Günlük kazanç",
    "Totalprofit": "Toplam kazanç",
    "Quantity": "Miktar",
    "RentPrice": "Kiralama Ücreti",
    "RentMiner": "Madenci kirala",
    "Insufficient": "Yetersiz ${name}",
    "InsufficientMsg": "{num} ${name1} gerekiyor, daha fazla ${name2} kazanmak için arkadaş davet et veya görevleri tamamla.",
    "Settings": "Ayarlar",
    "copyid": "ID'yi kopyala",
    "UpgradeSuccessfully": "Başarıyla Yükseltildi",
    "Name": "İsim",
    "userinfo": "Kullanıcı bilgisi",
    "disconnect": "Ayrıl",
    "Startmining": "Madenciliğe başla",
    "Welcome": "{name}'ya hoş geldin",
    "Withdrawal": "Çekim",
    "Minimumamount": "Minimum miktar",
    "Networkfee": "Ağ ücreti",
    "Enteramount": "Miktarı girin",
    "Submit": "Gönder",
    "MinimumTip": "Çekim miktarı çok az. Minimum çekim miktarı: {num}",
    "MaximumTip": "Yetersiz miktar, çekebileceğiniz maksimum miktar: {num}",
    "SubmittedTip": "Gönderildi, işlenmesi 30-60 çalışma günü bekleniyor",
    "WithdrawStatus": "Durum",
    "Submissiontime": "Gönderim zamanı",
    "WithdrawAwaitTip": "* İşlenmesinin 30-60 çalışma günü sürmesi bekleniyor. Daha fazla arkadaş davet etmek inceleme sürecini hızlandırabilir.",
    "Processing": "İşleniyor",
    "Amount": "Miktar",
    "Numberoffriends": "Aktif arkadaş sayısı: {now}/{limit}",
    "InviteTip": "İlk çekiminizi yapmak için {limit} arkadaşı madencilik uygulamasına davet etmeniz gerekiyor.",
    "openonphone": "Telefonunuzda bu bağlantıyı açın.",
    "claimTip": "Alınacak miktar çok az. Alınabilecek minimum miktar: {num}",
    "WalletBalance": "Cüzdan Bakiyesi",
    "Withdraw": "Çekim Yap",
    "SetWalletAddress": "Cüzdan Adresini Ayarla",
    "WithdrawalRecord": "Çekim Kaydı",
    "Norecords": "Kayıt yok",
    "Whatis": "{name} nedir?",
    "All": "Hepsi",
    "save": "Kaydet",
    "successWithdrawal": "Çekim alındı {num}",
    "secondsago": "{time} saniye önce",
    "Loading": "Yükleniyor...",
    "PaymentConfirming": "İşlem Durumunu Kontrol Ediyor...",
    "Check": "Kontrol Et",
    "CheckFail": "İşlem tamamlanmadı. Lütfen 5 saniye sonra tekrar kontrol edin.",
    "Addname": "'{name}' isminize ekleyin",
    "Restattcheck": "Kontrol etmek için uygulamayı yeniden başlatın",
    "Copyname": "'{name}' kopyala",
    "SubmissionFailed": "Gönderim başarısız oldu, lütfen daha sonra tekrar deneyin",
    "WithdrawalReview": "Çekim incelemesi",
    "WebWithdrawAwaitTip": "* İşlenmesinin 24-48 saat sürmesi bekleniyor. Daha fazla arkadaş davet etmek inceleme sürecini hızlandırabilir.",
    "Success": "Başarılı",
    "Rejection": "Reddetme",
    "WebSubmittedTip": "Gönderildi, işlenmesi 24-48 saat bekleniyor",
    "shop": "Mağaza",
    "topurchase": "Satın almak için mağazaya gidin",
    "shopDesc": "Sınırlı erişim—kaybolmadan önce sahip olun!",
    "claim": "Ödül topla",
    "payment_success": "Ödeme başarılı",
    "payment_failed": "Ödeme başarısız",
    "payment_cancelled": "Ödeme iptal edildi",
    "opening_payment": "Ödeme açılıyor...",
    "payment_status": "Ödeme durumu",
    "create_order_failed": "Sipariş oluşturma başarısız",
    "creating_ton_order": "TON siparişi oluşturuluyor...",
    "next_step": "Sonraki adım",
    "use_ton_payment": "TON ödemesini kullanın",
    "start_transaction": "İşlemi başlat",
    "connect_wallet": "Cüzdanı bağlayın",
    "address": "Adres",
    "amount_ton": "Miktar TON",
    "copy": "Yapıştır",
    "amount": "Miktar",
    "wallet_address": "Cüzdan adresi",
    "comment_memo": "Açıklama notu",
    "you_can_choose_to_connect_wallet_to_pay": "Ödemek için cüzdan bağlamayı seçebilirsiniz",
    "or_manually_transfer_to_the_above_address": "Ya da yukarıdaki adrese manuel olarak transfer edebilirsiniz (miktarın ve notun tam olarak aynı olması gerekiyor)",
    "transaction_success": "İşlem başarılı",
    "transaction_failed": "İşlem başarısız",
    "transaction_error": "İşlem hatası",
    "transaction_status": "İşlem durumu",
    "transaction_id": "İşlem kimliği",
    "transaction_amount": "İşlem miktarı",
    "transaction_status_desc": "İşlem durumu açıklaması",
    "payment_status_tip": "Lütfen ödemenin onaylanmasını bekleyin",
    "select_payment_method": "Ödeme yöntemini seçin",
    "total_amount": "Toplam miktar",
    "creating_order": "Sipariş oluşturuluyor...",
    "order_created": "Sipariş oluşturuldu",
    "order_status": "Sipariş durumu",
    "Applyforwithdrawal": "Para çekme başvurusu yap",
    "Withdrawalunlock": "Para çekme kilidinin açılması",
    "WithdrawalunlockTip": "Para çekmeyi açmak için {num} davet edilen arkadaşınız olmalı",
    "Close": "Kapat",
    "Delivering": "Teslim ediliyor",
    "Duetothelargenumber": "Alıcı sayısının çok olması nedeniyle, hava droppunuzun 15-20 iş günü içinde ulaşması bekleniyor",
    "select_network": "Ağı seçin",
    "confirm": "onayla",
    "switching_network": "Ağaç geçiş yapılıyor...",
    "network_switched": "Ağaç değişti",
    "use_usdt_payment": "USDT ödemesi kullanın",
    "or_manually_transfer_to_the_above_address_usdt": "Yukarıdaki adrese manuel olarak transfer edin (miktarın ve adresin tam olarak aynı olması gerektiğini unutmayın)",
    "chain_type": "Ağ",
    "check_transaction_status": "İşlem durumunu kontrol et",
    "transaction_wait": "İşlem devam ediyor. Uygulamadan çıkabilirsiniz. İşlem tamamlandığında sizi bilgilendirecek bir mesaj alacaksınız.",
    "twa_pay_tip_with_memo": "Lütfen adresin, miktarın ve notun transfer için tutarlı olduğundan emin olun.",
    "twa_pay_tip": "Lütfen adresin ve miktarın transfer için doğru olduğundan emin olun.",
    "creating_usdt_order": "USDT siparişi oluşturuluyor...",
    "affiliate_programs": "Ortaklık programları",
    "affiliate_programs_description": "Arkadaşlarınızı madencilik uygulamasına davet edin ve ödüller kazanın.",
    "commission_details": "Komisyon detayları",
    "no_commission_records": "Komisyon kaydı yok",
    "commission_list": "Komisyon listesi",
    "input_amount": "Tutar girin",
    "max": "Maks",
    "commission_input_amount": "Komisyon tutarını girin",
    "min_commission": "Asgari çekim tutarı {num}'dir",
    "WithdrawalSuccess": "Çekim başarılı",
    "WithdrawalFailed": "Çekim başarısız",
    "WithdrawalProcessing": "Çekim işleniyor",
    "award": "Ödül",
    "level": "Level",
    "Share_to_group": "Gruba paylaş",
    "Exchange": "Değişim",
    "balance_not_enough": "Bakiye yetersiz, sadece {num} {coin} değiştirebilirsiniz",
    "exchange_fail": "Değişim başarısız",
    "exchange_success": "Değişim başarılı",
    "you_will_receive": "Alacaksınız",
    "ShareToGroups": "Gruplara paylaş",
    "Numberofgroups": "Grup sayısı: {now}/{limit}",
    "Confirm": "Onayla",
    "ShareToGroupsDesc": "Daha fazla {name} almak için gruplara paylaş",
    "TokenAddress": "Lütfen borsa ID'si veya USDT adresi gibi para çekme bilgilerini girin",
    "CashAddress": "Lütfen banka kartı numarası veya USDT adresi gibi para çekme bilgilerini girin",
    "Cancel": "İptal",
    "min_withdrawal_amount": "Minimum para çekme tutarı {num} {coin}",
    "max_withdrawal_amount": "Maksimum para çekme tutarı {num} {coin}",
    "withdrawal_failed": "Para çekme başarısız oldu",
    "withdrawal_success": "Para çekme başarılı",
    "PayNow": "Şimdi öde",
    "PaySkip": "Çekimi anında açmak için {num} ödeyin",
    "NumberofGroups": "Grup sayısı: {now}/{limit}",
    "SendMessage": "Mesaj gönder",
    "NumberofShares": "Paylaşım sayısı: {now}/{limit}",
    "NumberofTasks": "Görev sayısı: {now}/{limit}",
    "CompleteTask": "Görevi tamamla",
    "PleaseEnterValidAmount": "Lütfen Geçerli Miktarı Girin",
    "PleaseEnterValidEmail": "Lütfen Geçerli E-posta Girin",
    "Feedback": "Geri Bildirim",
    "Inputfeedbackcontent": "Geri bildirim içeriğini girin",
    "Submitfeedback": "Geri bildirimi gönder",
    "Pleaseenteravalidemailaddress": "Lütfen geçerli bir e-posta adresi girin",
    "Pleaseenteryouremailaddress": "Lütfen e-posta adresinizi girin",
    "Youhavealreadyfeedbackedtoday_pleasecomebacktomorrow": "Bugün zaten geri bildirim verdiniz, lütfen yarın geri dönün",
    "Feedback_submitted_successfully_thank_you_for_your_valuable_feedback": "Geri bildirim başarıyla gönderildi, değerli geri bildiriminiz için teşekkür ederiz",
    "Feedback_submission_failed_please_retry": "Geri bildirim gönderimi başarısız oldu, lütfen tekrar deneyin",
    "ContactUs": "Bize Ulaşın",
    "XRPAddress": "Lütfen etkinleştirilmiş XRP zincir cüzdan adresini (MEMO dahil) doldurun, aksi takdirde nakit çekemezsiniz.",
    "Accelerated": "Hızlandırılmış",
    "Accelerated_withdrawals_success": "Hızlandırılmış çekimler başarıyla",
    "login": "Giriş Yap",
    "register": "Kayıt Ol",
    "login_with_google": "Google ile giriş yap",
    "or": "VEYA",
    "email": "E-posta",
    "password": "Şifre",
    "no_account": "Hesabınız yok mu",
    "click_to_go": "Tıkla",
    "have_account": "Zaten bir hesabınız var mı",
    "go_to": "Git",
    "invite_code": "Davet Kodu",
    "optional": "İsteğe Bağlı",
    "google_login_not_ready": "Google girişi hazır değil, lütfen daha sonra tekrar deneyin",
    "password_too_long": "Şifre çok uzun",
    "weak": "Zayıf",
    "medium": "Orta",
    "strong": "Güçlü",
    "login_success": "Giriş başarılı",
    "login_failed": "Giriş başarısız",
    "please_input_email": "Lütfen e-posta adresinizi girin",
    "invalid_email": "Geçersiz e-posta formatı",
    "please_input_password": "Lütfen şifrenizi girin",
    "password_length_6_to_16": "Şifre 6-16 karakter olmalıdır",
    "account_or_password_error": "Hesap veya şifre hatası",
    "register_success": "Kayıt başarılı",
    "register_failed": "Kayıt başarısız",
    "save_error": "Kaydetme hatası, lütfen daha sonra tekrar deneyin",
    "ShareToFriends": "Arkadaşlarla paylaş",
    "login_first": "Lütfen önce giriş yapın",
    "WalletBscError": "❌ Geçersiz BNB Chain cüzdan adresi.",
    "DownloadWallet": "Cüzdanı İndir",
    "AddToHomeScreen": "Ana ekranına {appName} ekle",
    "TapShareInToolbar": "Araç çubuğuna dokunun",
    "SelectAddToHomeScreen": "Ana ekranı ekle'yi seçin",
    "OpenToolbar": "Araç Çubuğunu Aç",
    "ClaimFailed": "Ödüller alınamadı, lütfen daha sonra tekrar deneyin",
    "guest_login": "Misafir Girişi",
    "please_input_phone": "Lütfen telefon numaranızı girin",
    "email_error_1": "Lütfen e-posta adresinizi girin",
    "email_error_2": "Lütfen geçerli bir e-posta adresi girin",
    "email_error_3": "Misafir e-posta adresine izin verilmemektedir, lütfen gerçek bir e-posta kullanın",
    "phone": "Telefon",
    "phone_error_1": "Lütfen telefon numaranızı girin",
    "phone_error_2": "Lütfen geçerli bir telefon numarası girin",
    "update_info": "Bilgileri Güncelle",
    "update_success": "Güncelleme başarılı",
    "update_failed": "Güncelleme başarısız oldu, lütfen daha sonra tekrar deneyin",
    "cancel": "İptal",
    "guest_credentials_title": "Hesap Bilgisi",
    "guest_credentials_warning": "Lütfen hesabınızı ve şifrenizi kaydetmek için bir ekran görüntüsü alın. Kaybedilirse, kazançlarınız geri alınamaz!",
    "i_have_saved": "Kayıtlıyım",
    "account": "Hesap",
    "view_credentials": "Kimlik Bilgilerini Görüntüle",
    "miner_max_reached": "Bu madencinin maksimum sayısına ulaştınız"
}};